declare global {
  interface Window {
    ReactNativeWebView: any;
  }
}
class ReactNativeService {
  isReactNativeWebView() {
    try {
      return typeof window.ReactNativeWebView !== 'undefined';
    } catch {
      return false;
    }
  }
}

const ReactNative = new ReactNativeService();

export default ReactNative;
